import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m13.826 14.643-6.66 3.218c-.792.371-1.398-.248-1.027-1.04l3.218-6.647c.198-.408.458-.656.817-.829l6.635-3.206c.841-.396 1.435.223 1.04 1.04l-3.194 6.634a1.74 1.74 0 0 1-.83.83Zm-3.268-2.637c0 .805.644 1.448 1.448 1.448a1.45 1.45 0 0 0 1.448-1.448c0-.792-.656-1.448-1.448-1.448a1.45 1.45 0 0 0-1.448 1.448Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24 11.994C24 18.566 18.566 24 12.006 24S0 18.566 0 11.994C0 5.434 5.434 0 11.994 0S24 5.434 24 11.994Zm-2 0C22 17.463 17.46 22 12.006 22 6.55 22 2 17.46 2 11.994 2 6.538 6.538 2 11.994 2 17.452 2 22 6.541 22 11.994Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionSafari24 = createIcon(IconComponent);